import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IAccountStatistics  extends IAccountObjectArgs {
    jobStatistics: IJobStatistics;
}

export interface IJobStatistics {
    counts: {
        total: number;
        byAccessGroup: IStatistic;
        byJobType: IStatistic;
        byJobStatus: IStatistic;
    };
}

export interface IStatistic {
    [id: string]: number;
}

const defaults = () => ({
    jobStatistics: {}
});

export class AccountStatistics extends AccountObject {
    jobStatistics: IJobStatistics;

    static makeModelFromApiResponse(object: IAccountStatistics, account: string): AccountStatistics {
        return new AccountStatistics({ ...object, account });
    }

    constructor(data?: IAccountStatistics) {

        data = {
            ...data,
            id: data.account
        };

        super({...defaults(), ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.model.ts